var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 190 265",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow_svg__a)",
  filter: "url(#arrow_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.9,
  stroke: "#0A0A0A",
  strokeWidth: 5.933,
  d: "M41.715 129.828a9.05 9.05 0 0 0 .657 3.878 9.5 9.5 0 0 0 2.257 3.298l85.833 81.098c1.973 1.708 4.568 2.63 7.243 2.574s5.225-1.086 7.115-2.875 2.978-4.2 3.033-6.727c.056-2.528-.924-4.978-2.735-6.84l-78.813-74.426 78.813-74.465c1.883-1.852 2.923-4.327 2.896-6.894s-1.119-5.023-3.04-6.838-4.52-2.847-7.237-2.872c-2.717-.026-5.337.956-7.296 2.736l-85.79 81.098a9.5 9.5 0 0 0-2.277 3.325 9.1 9.1 0 0 0-.66 3.91z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.358 0h189v265h-189z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "arrow_svg__b",
  width: 191.35,
  height: 266.978,
  x: -0.817,
  y: 0.175,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.955
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 19.776
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 15.821
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9.888
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1_2",
  result: "effect2_dropShadow_1_2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 7.91
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.91
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_1_2",
  result: "effect3_dropShadow_1_2"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow_1_2",
  result: "shape"
})))));
export default SvgArrow;